//Librairies
import React, { useEffect, useState } from "react";
import gsap from "gsap";
import { ThemeProvider } from "styled-components";
//Components
import Home from "./sections/Home";
import Project from "./sections/Project";
import Social from "./components/Social";
import NavMenu from "./components/NavMenu";
import Contact from "./sections/Contact";
import GlobalStyles from "./styles/globalStyles";
import About from "./sections/About";
import { theme } from "./styles/Themes.js";
import Intro from "./sections/Intro";

function App() {
  let timeline = gsap.timeline({ defaults: { ease: "power1.out" } });

  //Intro Scroll 

  const [scrollHidden, setScrollHidden] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setScrollHidden(false);
    },3000)
  },[])

  return (
      <ThemeProvider theme={theme}>
        <GlobalStyles scroll={scrollHidden}/>
        <Intro timeline={timeline} />
        <Home timeline={timeline}/>
        <NavMenu timeline={timeline} />
        <Social timeline={timeline} />
        <About />
        <Project />
        <Contact />
      </ThemeProvider>
  );
}

export default App;
